<template>
  <CRow>
    <template v-for="balance in balances">
      <div class="col-md-5 text-gray-600 ml-3 card-home-balance" :class="channelTypeCode[balance.channel]">
        <div class="d-flex justify-content-between title-card-home-balance">
          <p class="mb-0 ml-2">
            {{ $t(`home.campaignSumary.${channelTypeCode[balance.channel]}-available`) }}
          </p>
          <CIcon
            :name="channelTypeCode[balance.channel]"
            class="icon-card-home-balance"
            size="custom-size"
            label="teste"
            :height="25"
            viewBox="0 0 32 32"
          />
        </div>
        <div class="number-card-home-balance mt-3">{{ formatNumber(balance.currentBalance) }}</div>
      </div>
    </template>
  </CRow>
</template>

<script>
import { formatNumber } from '@/utils/numbersFormatUtil.js'
import { PLAN_TYPES } from '@/views/plansSubscriptions/constants'

const channelTypeCode = {
  1: 'email',
  2: 'sms',
}
export default {
  name: 'balance',
  props: {
    balances: Array,
    default: [],
    planType: String,
  },
  data() {
    return {
      channelTypeCode,
      PLAN_TYPES
    }
  },
  methods: {
    formatNumber(value) {
      return formatNumber(value)
    },
  }
}
</script>

<style>
.sms {
  background-color: #ebff99;
  border-radius: 12px;
  min-height: 120px;
  padding: 20px;
}

.email {
  background-color: #dbf1f8;
  border-radius: 12px;
  min-height: 120px;
  padding: 20px;
}

.title-card-home-balance {
  font-weight: 700;
  color: #343a40;
}

.icon-card-home-balance {
  color: #343a40;
}

.number-card-home-balance {
  font-weight: 700;
  color: #343a40;
  font-size: 24px;
  margin-left: 5px;
}

.card-home-balance {
  margin-top: 20%;
}
</style>
